import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CmspageService } from '../cmspage.service';
import { Page } from '../page';
import { switchMap, takeUntil} from 'rxjs/operators';

import { Subject } from 'rxjs';
@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  schoolServiceDATA:any;
  page: Page;
  error: {};

  constructor(
    private route: ActivatedRoute,
    private cmspageService: CmspageService
    ) { }

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.cmspageService.getPage(params.get('slug'))
      )
    ).pipe(takeUntil(this.destroy$)).subscribe(
      (data: Page) => this.page = data,
      error => this.error = error
    );
   this.cmspageService.getSchoolList().pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.schoolServiceDATA =response;
    }); 



  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
